import { useEffect, useState } from 'react'

import { subscriptionAPI } from '../api/services/subscription'
import { SubscriptionPricing } from '../api/services/subscription/types.ts'

const useSubscriptionPricing = () => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [prices, setPrices] = useState<SubscriptionPricing[] | null>(null)
  const [stripeProduct, setStripeProduct] = useState(null)
  const [customerId, setCustomerId] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await subscriptionAPI.getSubscriptionPricing()

        if (response.error) {
          setError(response.error)
          setLoading(false)
          return
        }

        if (response.length > 0) {
          const stripeProduct = response[0]
          const pricesData: SubscriptionPricing[] = response[0].prices

          pricesData.sort((a, b) => {
            if (a.interval < b.interval) return -1
            if (a.interval > b.interval) return 1
            return a.interval_count - b.interval_count
          })

          setCustomerId(response[0].customer_id)
          setStripeProduct(stripeProduct)
          setPrices(pricesData)
        }
      } catch {
        setError('Something went wrong while fetching pricing data.')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  return { customerId, stripeProduct, prices, loading, error }
}

export default useSubscriptionPricing
